import type { AppIconProps } from '../Icons.types';
import { getClassNames } from '../Icons.utils';
import styles from './UsersGroup.module.scss';

export const AppUsersGroupIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg
      {...rest}
      className={classNames}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6666 14V12.6667C10.6666 11.9594 10.3856 11.2811 9.88554 10.781C9.38544 10.281 8.70716 10 7.99992 10H3.99992C3.29267 10 2.6144 10.281 2.1143 10.781C1.6142 11.2811 1.33325 11.9594 1.33325 12.6667V14M10.6666 2.08533C11.2384 2.23358 11.7448 2.56751 12.1064 3.03471C12.4679 3.50191 12.6641 4.07593 12.6641 4.66667C12.6641 5.25741 12.4679 5.83143 12.1064 6.29863C11.7448 6.76582 11.2384 7.09975 10.6666 7.248M14.6666 14V12.6667C14.6661 12.0758 14.4695 11.5018 14.1075 11.0349C13.7455 10.5679 13.2387 10.2344 12.6666 10.0867M8.66658 4.66667C8.66658 6.13943 7.47268 7.33333 5.99992 7.33333C4.52716 7.33333 3.33325 6.13943 3.33325 4.66667C3.33325 3.19391 4.52716 2 5.99992 2C7.47268 2 8.66658 3.19391 8.66658 4.66667Z"
        stroke="#737781"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
